import styled from 'styled-components';

export const Thumb = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const Stars = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;
